module.exports = __webpack_public_path__ + "img/case-logo-06.9bb93bd5.png";